import api from "./axiosInstance";

const API_ROOT = `${process.env.REACT_APP_API_URL}/Dashboard`;

const notificationService = {
  getAll: async () => (await api.get(API_ROOT)).data || [],
}

export default notificationService
